import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { NullableType } from '@/types'
import type { AppState, DrawerType, ModalType, Moment, MenuItem } from './types'
import type { Company } from '@/api/models/company'

const initialState: AppState = {
  drawerOpened: null,
  modalOpened: null,
  user: null,
  employee: null,
  baseUrl: null,
  userCompanies: null,
  activeCompany: null,
  menuAccess: null,
  userRoles: null,
  history: null,
  medJournalAwaiting: null,
  employeesImportNotification: null,
  activeHasBranches: null,
  currentHasBranches: null,
}

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setDrawer: (
      state,
      { payload }: PayloadAction<NullableType<DrawerType>>
    ) => {
      state.drawerOpened = payload
    },
    setModal: (state, { payload }: PayloadAction<NullableType<ModalType>>) => {
      state.modalOpened = payload
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setUser: (state, { payload }: PayloadAction<any>) => {
      state.user = payload
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setEmployee: (state, { payload }: PayloadAction<any>) => {
      state.employee = payload
    },
    setBaseUrl: (state, { payload }: PayloadAction<string>) => {
      state.baseUrl = payload
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setActiveCompany: (state, { payload }: PayloadAction<any>) => {
      state.activeCompany = payload
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setHistory: (state, { payload }: PayloadAction<Moment[]>) => {
      state.history = payload
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setMenuAccess: (state, { payload }: PayloadAction<any>) => {
      state.menuAccess = payload
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setUserRoles: (state, { payload }: PayloadAction<string[]>) => {
      state.userRoles = payload
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setMedJournalAwaiting: (state, { payload }: PayloadAction<any>) => {
      state.medJournalAwaiting = payload
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setUserCompanies: (state, { payload }: PayloadAction<any>) => {
      state.userCompanies = payload
    },
    setEmployeesImportNotification: (
      state,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      { payload }: PayloadAction<any>
    ) => {
      state.employeesImportNotification = payload
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setActiveHasBranches: (state, { payload }: PayloadAction<boolean>) => {
      state.activeHasBranches = payload
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setCurrentHasBranches: (state, { payload }: PayloadAction<boolean>) => {
      state.currentHasBranches = payload
    },
  },
})

export const {
  setDrawer,
  setModal,
  setUser,
  setEmployee,
  setBaseUrl,
  setUserCompanies,
  setActiveCompany,
  setMenuAccess,
  setHistory,
  setMedJournalAwaiting,
  setEmployeesImportNotification,
  setActiveHasBranches,
  setCurrentHasBranches,
  setUserRoles,
} = appSlice.actions
